module.exports = __webpack_public_path__ + "img/fond.71b2e3ca.svg";